import "@/App.css";
import "@/components/game/game.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { CategoriesProvider } from "@/context/CategoriesContext";
import { UnsavedProvider } from "@/context/UnsavedContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Nav } from "@/components/Nav";
import LoginPage from "@/pages/Login";
import RecordPage from "@/pages/Record";
import SubmissionsPage from "@/pages/Submissions";
import AdminPage from "@/pages/Admin";
import BibliotheekPage from "@/pages/Bibliotheek";
import WhatsNewPage from "@/pages/WhatsNew";
import AccountPage from "@/pages/Account";
import NotFoundPage from "@/pages/NotFound";
import GamePage from "@/pages/Game";
import KeywordsPage from "@/pages/Keywords";
import { CONFIG_ERROR } from "@/lib/api";
import { ConfigurationError } from "@/components/ConfigurationError";

function AppShell({ children }) {
  return (
    <div className="min-h-screen bg-tw-black text-white">
      <Nav />
      {/* pb accounts for the fixed mobile bottom nav (~64px + safe-area) */}
      <main className="pb-24 xl:pb-0">{children}</main>
    </div>
  );
}

function App() {
  if (CONFIG_ERROR) return <ConfigurationError />;
  return (
    <div className="App">
      <AuthProvider>
        <CategoriesProvider>
        <UnsavedProvider>
          <BrowserRouter>
            <Routes>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/weekstand" element={<ProtectedRoute><AppShell><GamePage /></AppShell></ProtectedRoute>} />
              <Route path="/trefwoorden" element={<ProtectedRoute blockReader><AppShell><KeywordsPage /></AppShell></ProtectedRoute>} />
              <Route
                path="/"
                element={
                  <ProtectedRoute blockReader>
                    <AppShell>
                      <RecordPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/submissions"
                element={
                  <ProtectedRoute blockReader>
                    <AppShell>
                      <SubmissionsPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/bibliotheek"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <BibliotheekPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/wat-is-nieuw"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <WhatsNewPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/account"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <AccountPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute adminOnly>
                    <AppShell>
                      <AdminPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
              <Route
                path="*"
                element={
                  <ProtectedRoute>
                    <AppShell>
                      <NotFoundPage />
                    </AppShell>
                  </ProtectedRoute>
                }
              />
            </Routes>
          </BrowserRouter>
        </UnsavedProvider>
        </CategoriesProvider>
        <Toaster
          theme="dark"
          position="top-center"
          offset={{ top: 80 }}
          mobileOffset={{ top: 72, left: 16, right: 16 }}
          toastOptions={{
            style: {
              background: "#141414",
              border: "1px solid #262626",
              color: "#FFFFFF",
              borderRadius: 0,
              fontFamily: "'DM Sans', sans-serif",
            },
          }}
        />
      </AuthProvider>
    </div>
  );
}

export default App;
